import classNames from 'clsx';
import React, { type ReactElement } from 'react';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './MainPageDisableWrapper.css';

interface Props {
    disabled: boolean;
    disableContent?: ReactElement;
    children: ReactElement;
    className?: string;
}

const MainPageDisableWrapper = ({ disableContent, disabled, children, className }: Props) => {
    const isDarkTheme = isDarkThemeModeEnabled();

    if (!disabled) {
        return children;
    }

    return (
        <div className={classNames(styles.wrapper, className)}>
            <div
                className={classNames(styles.background, {
                    [styles.darkBackground]: isDarkTheme,
                })}
            >
                {disableContent && <div className={styles.content}>{disableContent}</div>}
            </div>
            {children}
        </div>
    );
};

export default MainPageDisableWrapper;
